import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-drop-down-item',
  templateUrl: './drop-down-item.component.html',
  styleUrls: ['./drop-down-item.component.scss']
})
export class DropDownItemComponent implements OnInit {

  @Input() icon = '';

  constructor() { }

  ngOnInit() {
  }

}
